module.exports = __webpack_public_path__ + "static/img/4.fbe7b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userMethods/4.png
// module id = VO/l
// module chunks = 0